import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Wrapper from './styled';

const TONE_LABEL_ID = {
  online: 'mcp.status.online',
  offline: 'mcp.status.offline',
  unsupported: 'mcp.status.unsupported'
};

const StatusPill = ({
  isOnline,
  tone,
  className
}) => {
  const intl = useIntl();
  const resolvedTone = tone || (isOnline ? 'online' : 'offline');

  return (
    <Wrapper $tone={ resolvedTone } className={ className }>
      {intl.formatMessage({ id: TONE_LABEL_ID[resolvedTone] })}
    </Wrapper>
  );
};

StatusPill.propTypes = {
  isOnline: PropTypes.bool,
  tone: PropTypes.oneOf(['online', 'offline', 'unsupported']),
  className: PropTypes.string
};

StatusPill.defaultProps = {
  isOnline: false,
  tone: null,
  className: ''
};

export default StatusPill;
